<template>
    <div class="py-4 container-fluid">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">

                        <!-- Side Navigation -->
                        <div class="col-lg-3">
                            <edit-inactive-animal-side-nav />
                        </div>

                        <!-- Animal Details -->
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <animal-inactive-detail />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EditInactiveAnimalSideNav from "./components/EditInactiveAnimalSideNav.vue";
import AnimalInactiveDetail from "./components/AnimalInactiveDetail.vue";

export default {
    name: "Animal_edit_inactive_page",

    components: {
        EditInactiveAnimalSideNav,
        AnimalInactiveDetail
    },

    data() {
        return {
            Id: "",
            animal: [],
            gets: []
        };
    },

    async mounted() {        
    }
};
</script>